import PropTypes from 'prop-types';
import EBPropTypes from 'js-utils/prop-types';
import { PACKAGE_ONE, PACKAGE_THREE, PACKAGE_TWO } from './main';

export const ASSORTMENT_TAX_PROP_TYPES = PropTypes.shape({
    taxDescription: EBPropTypes.translation,
    needTaxDescription: PropTypes.bool,
});

export const ASSORTMENTS_TAX_PROP_TYPE = PropTypes.shape({
    [PACKAGE_ONE]: ASSORTMENT_TAX_PROP_TYPES,
    [PACKAGE_TWO]: ASSORTMENT_TAX_PROP_TYPES,
    [PACKAGE_THREE]: ASSORTMENT_TAX_PROP_TYPES,
}).isRequired;

export const ASSORTMENTS_UNFORMATTED_PER_PLAN_PRICING_PROP_TYPE = PropTypes.shape(
    {
        name: PropTypes.string,
        feeFixed: PropTypes.number,
        feePercent: PropTypes.number,
    },
);

export const ASSORTMENTS_FORMATTED_PER_PLAN_PRICING_PROP_TYPE = PropTypes.shape(
    {
        formattedFee: EBPropTypes.translation,
        formattedMax: PropTypes.string,
        formattedProcessingFee: PropTypes.string,
    },
);

export const ASSORTMENTS_UNFORMATTED_PRICING_PROP_TYPE = {
    assortmentsPricing: PropTypes.shape({
        [PACKAGE_ONE]:
            ASSORTMENTS_UNFORMATTED_PER_PLAN_PRICING_PROP_TYPE.isRequired,
        [PACKAGE_TWO]:
            ASSORTMENTS_UNFORMATTED_PER_PLAN_PRICING_PROP_TYPE.isRequired,
    }).isRequired,
};

export const ASSORTMENTS_FORMATTED_PRICING_PROP_TYPE = {
    feeBreakdown: PropTypes.shape({
        [PACKAGE_ONE]:
            ASSORTMENTS_FORMATTED_PER_PLAN_PRICING_PROP_TYPE.isRequired,
        [PACKAGE_TWO]:
            ASSORTMENTS_FORMATTED_PER_PLAN_PRICING_PROP_TYPE.isRequired,
        [PACKAGE_THREE]:
            ASSORTMENTS_FORMATTED_PER_PLAN_PRICING_PROP_TYPE.isRequired,
    }).isRequired,
    assortmentsTax: PropTypes.shape(ASSORTMENTS_TAX_PROP_TYPE),
};

export const SIGNUPPAGE_ASSORTMENTS_PRICING_PROP_TYPE = PropTypes.shape({
    [PACKAGE_ONE]: PropTypes.string,
    [PACKAGE_TWO]: PropTypes.string,
    [PACKAGE_THREE]: EBPropTypes.translation,
}).isRequired;
